import React from "react";
import PageHeader from "../components/marketing/PageHeader";
import Events from "../components/marketing/Events";
import { useContent } from "../context/ContentContext";

export default function EventsPage() {
  const { events } = useContent();
  return (
    <div data-testid="events-page">
      <PageHeader
        overline="What's Coming"
        title={<>Events &amp; <span className="italic gold-gradient-text">workshops</span>.</>}
        subtitle="Recitals, intensives and showcases — join us on and off the stage throughout the year."
        image="https://images.unsplash.com/photo-1609602961949-eddbb90383cc?crop=entropy&cs=srgb&fm=jpg&q=85"
      />
      <Events items={events} heading={false} />
    </div>
  );
}
